import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import {
  UiGridCommonService,
  ScriptLoaderService,
} from '@everymatrix-base-components/utils';

const scriptLoader = new ScriptLoaderService('modules');
const module = 'ui-grid-bridge';
const report = 'everymatrix-mm-verification-report';

scriptLoader
  .loadAngularJsAndUiGridIfNeeded()
  .then(() => {
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .then(() => {
        let lastInitializedTarget: Element | null = null;

        const tryInit = () => {
          const host = document.querySelector(report);
          const shadow = host?.shadowRoot;
          const target = shadow?.querySelector(`.${report}`);

          // If no target found, clear reference
          if (!target) {
            if (lastInitializedTarget) {
              lastInitializedTarget = null;
            }
            return;
          }

          // If this is a new target (new DOM instance), init again
          if (target !== lastInitializedTarget) {
            UiGridCommonService.init(target, module);
            lastInitializedTarget = target;
          }
        };

        // Observer to track DOM changes continuously
        const observer = new MutationObserver(() => {
          tryInit();
        });

        observer.observe(document.body, { childList: true, subtree: true });

        // Initial check
        tryInit();
      });
  })
  .catch((err) => console.error(err));
